// ** React Imports
import { Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

// ** Redux Imports
import { store } from './redux/store'
import { Provider } from 'react-redux'

// ** Intl, CASL & ThemeColors Context
import ability from './configs/acl/ability'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext } from './utility/context/ThemeColors'

// ** ThemeConfig
// import themeConfig from './configs/themeConfig'
import DynamicTheme from '@components/stylesheets/DynamicTheme'

// ** Toast
import { Toaster } from 'react-hot-toast'

// ** i18n
import './configs/i18n'

// ** Spinner/Splash Screen
import Spinner from '@components/spinners/Fallback-spinner'

// ** Ripple Button
import '@components/ripple-button'

// ** Fake Database
import './@fake-db'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Hot Toast Styles
import '@styles/react/libs/react-hot-toasts/react-hot-toasts.scss'

// ** Core styles
import '@assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

import '@root-assets/css/vcronglobal.rev2.css'

// ** Service Worker
// import * as serviceWorker from './serviceWorker'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
    <>
        <Provider store={store}>
            <DynamicTheme />
            <BrowserRouter>
                <Suspense fallback={<Spinner />}>
                    <AbilityContext.Provider value={ability}>
                    <ThemeContext>
                        <LazyApp />
                    </ThemeContext>
                    </AbilityContext.Provider>
                </Suspense>
            </BrowserRouter>
        </Provider>
  </>
)

// To work offline and load faster change unregister() to register() below. 
// serviceWorker.unregister()
